<template>
    <div class="tree-select">
        <div @click="handleShow">
            <el-input :disabled="disabled" v-model="nodeName"></el-input>
        </div>
        <el-dialog v-model="dialogVisible" title="组织机构树" width="600px" :close-on-click-modal="false">
            <div style="padding: 10px">
                <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
            </div>
            <el-tree
                class="my-tree"
                ref="tree"
                style="margin-top: 5px"
                :data="treeData"
                :node-key="nodeKey"
                :current-node-key="nodeId"
                default-expand-all
                highlight-current
                :expand-on-click-node="false"
                :filter-node-method="filterNode"
                @node-click="handleNodeClick"
            >
                <template #default="{ data }">
                    <div class="custom-tree-node">
                        <span class="menu-icon icon-org" v-if="data.EntityType == 101"></span>
                        <span class="menu-icon icon-shop" v-if="data.EntityType == 1"></span>
                        <span class="menu-icon icon-floor" v-if="data.EntityType == 2"></span>
                        <span class="menu-icon icon-market" v-if="data.EntityType == 3"></span>
                        <span>{{ data[labelName] }}</span>
                    </div>
                </template>
            </el-tree>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "TreeSelect",
    props: {
        nodeId: {
            type: String,
        },
        treeData: {
            required: true,
            type: Array,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        nodeKey: {
            type: String,
            default: "ID",
        },
        labelName: {
            type: String,
            default: "Name",
        },
    },
    data() {
        return {
            nodeName: "",
            dialogVisible: false,
            filterText: "",
        };
    },
    methods: {
        handleShow() {
            if (this.disabled) return false;
            this.dialogVisible = true;
        },
        filterNode(value, data) {
            if (!value) return true;
            console.log(data);
            return data[this.labelName].includes(value);
        },
        handleNodeClick(data) {
            this.dialogVisible = false;
            this.nodeName = data[this.labelName];
            this.$emit("select", data);
        },
        getTreeNodeName(treeNode, nodeId) {
            for (let node of treeNode) {
                if (node[this.nodeKey] === nodeId) {
                    this.nodeName = node[this.labelName];
                    return;
                }
                if (node.children) {
                    this.getTreeNodeName(node.children, nodeId);
                }
            }
        },
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        },
        nodeId: {
            handler(val) {
                if (val) {
                    this.getTreeNodeName(this.treeData, val);
                } else {
                    return false;
                }
            },
            immediate: true,
        },
    },
};
</script>

<style scoped>
.custom-tree-node .menu-icon {
    width: 20px;
    font-size: 18px;
    position: relative;
}
</style>
